import React, { useState } from "react";
import EyeOpen from '../../../../assets/svg/passInp-eyeIcons/eye-open.svg';
import EyeClose from '../../../../assets/svg/passInp-eyeIcons/eye-close.svg';
import "./fpComp.scss"

interface PasswordInputProps {
    placeholder: string;
    onChange?: (event: any) => void;
    onBlur?: (event: any) => void;
    value?: string;
    name?: string
}


function PasswordInput(props: PasswordInputProps) {
    const { onChange, onBlur, placeholder, value, name } = props;
    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <React.Fragment>
            <div className="password-input-container">
                <input
                    name={name ? name : "password"}
                    className="userInput passInput"
                    placeholder={placeholder}
                    type={passwordVisible ? 'text' : 'password'}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                />
                <img
                    src={passwordVisible ? EyeOpen : EyeClose}
                    alt="Toggle Password Visibility"
                    onClick={togglePasswordVisibility}
                    className="eye-icon"
                />
            </div>
        </React.Fragment>
    )
}

export default PasswordInput;